/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_DescInputs */

const vi_irrigation_schedule_desc = /** @type {(inputs: Irrigation_Schedule_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi loại lịch lưu cấu hình riêng, chỉ một lịch được áp dụng tại một thời điểm. Hệ thống tự bật và tự tắt bơm theo lịch đang áp dụng.`)
};

/**

* @param {Irrigation_Schedule_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_desc = /** @type {((inputs?: Irrigation_Schedule_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_desc(inputs)
});